import WeaLocaleProvider from "../wea-locale-provider";
const { getLabel } = WeaLocaleProvider;

// 橡皮擦
const dotSizeErase = {
  xxs: 16.0,
  xs: 16.0,
  sm: 32.0,
  md: 32.0,
  lg: 48.0,
  xl: 48.0
};

// 笔触
const dotsize = {
  xxs: 2.0,
  xs: 3.0,
  sm: 5.0,
  md: 6.0,
  lg: 9.0,
  xl: 10.0
};

// 手写模式笔触
const dotsizemin = {
  xxs: 1,
  xs: 1.2,
  sm: 1.4,
  md: 1.6,
  lg: 1.8,
  xl: 2
};
// 笔触尺寸
const brushs = ["xxs", "xs", "sm", "md", "lg", "xl"];

// 功能按钮
const getExtraBtns = () => {
  return [
    {
      key: "newLine",
      icon: "icon-coms-huanhang",
      name: getLabel(126869, "换行")
    },
    {
      key: "eraser",
      icon: "icon-coms-xiangpi",
      name: getLabel(513962, "橡皮擦")
    },
    {
      key: "cancel",
      icon: "icon-coms-Revoke2",
      name: getLabel(23757, "撤销")
    },
    {
      key: "clear",
      icon: "icon-coms-delete",
      name: getLabel(500578, "清空")
    }
  ];
};

//字体颜色
const normalColors = [
  "#000",
  "#f44483",
  "#ba58d1",
  "#2e6fd1",
  "#da4045",
  "#70bc99",
  "#00a661",
  "#da4044",
  "#d53365",
  "#de3b99",
  "#7e57bb",
  "#2989ad",
  "#54c9f4",
  "#67d8b6",
  "#f9c95f",
  "#fe475d",
  "#8269d9",
  "#c9ae00",
  "#ff8015",
  "#f73a53",
  "#c7436f",
  "#dda1f2",
  "#8d7ee2",
  "#8aafdd"
];

export default {
  dotsize,
  dotsizemin,
  brushs,
  extraBtns: getExtraBtns(),
  normalColors,
  dotSizeErase
};



// WEBPACK FOOTER //
// ./ecology9/wea-signature/constant.js